/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 料金システム用 API
 * PR TIMES 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BookingPlan
 */
export interface BookingPlan {
    /**
     * プランID
     * @type {string}
     * @memberof BookingPlan
     */
    id: string;
    /**
     * プラン名
     * @type {string}
     * @memberof BookingPlan
     */
    name: string;
    /**
     * 料金ラベル
     * @type {string}
     * @memberof BookingPlan
     */
    priceLabel: string;
    /**
     * プランの開始日
     * @type {string}
     * @memberof BookingPlan
     */
    startDate: string;
    /**
     * プランの終了日（従量課金プランは終了日がないためnullの場合がある）
     * @type {string}
     * @memberof BookingPlan
     */
    endDate: string | null;
    /**
     * 自動更新か（nullの場合は自動更新対象外のプラン）
     * @type {boolean}
     * @memberof BookingPlan
     */
    isAutoRenewable: boolean | null;
    /**
     * 一括支払いか（nullの場合は対象外のプラン）
     * @type {boolean}
     * @memberof BookingPlan
     */
    isLumpSumPayment: boolean | null;
}

export function BookingPlanFromJSON(json: any): BookingPlan {
    return BookingPlanFromJSONTyped(json, false);
}

export function BookingPlanFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingPlan {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'priceLabel': json['price_label'],
        'startDate': json['start_date'],
        'endDate': json['end_date'],
        'isAutoRenewable': json['is_auto_renewable'],
        'isLumpSumPayment': json['is_lump_sum_payment'],
    };
}

export function BookingPlanToJSON(value?: BookingPlan | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'price_label': value.priceLabel,
        'start_date': value.startDate,
        'end_date': value.endDate,
        'is_auto_renewable': value.isAutoRenewable,
        'is_lump_sum_payment': value.isLumpSumPayment,
    };
}

